import interceptedAxios from '../../../utils/interceptedAxios'

export async function deleteEmailGroup (
  groupId: string,
  onSuccess: (response: any, httpStatus: number) => void,
  onFailure: (errorMessage: string, httpStatus: number) => void
): Promise<void> {
  const url = `/communications-service/api/v1/udp/tiq/services/email/delete-group/${groupId}`
  try {
    const response = await interceptedAxios.delete(url, { timeout: 15000 })
    if (response?.status === 200 || response?.status === 204) {
      onSuccess(response.data, response.status)
    } else {
      onFailure(response.data?.error_message ?? 'Failed to delete group', response.status)
    }
  } catch (error: any) {
    // eslint-disable-next-line
    if (error?.response) {
      onFailure(error.response.data?.error_message ?? error.response.statusText, error.response.status)
    } else {
      onFailure('Network error', 0)
    }
  }
}
